module.exports = __webpack_public_path__ + "static/media/Africa.66e2e27c.svg";